import { LOGIN_SUCCESS, SET_IFRAME, LOGOUT, SET_SELECTED_ROLE, SET_CONFIGURATION_LIST, EXTERNAL_LOGIN_SUCCESS, SET_SELECTED_TIMEZONE, SET_TIMEZONE_LIST } from '../../common/actionTypes';
const INITIAL_STATE = {
  user: {
    id: null,
  },
  configurationList: [],
  iframe: [],
  selectedTimezone: [],
  timezoneList: []
};

const authReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return { ...state, user: action.payload };
    }
    case LOGOUT: {
      return { ...INITIAL_STATE };
    }
    case SET_SELECTED_ROLE: {
      return { ...state, selectedRole: action.payload };
    }
    case SET_CONFIGURATION_LIST: {
      return { ...state, configurationList: action.payload };
    }
    case SET_IFRAME: {
      return { ...state, iframe: action.payload };
    }
    case EXTERNAL_LOGIN_SUCCESS: {
      return { ...state, smartFlo: action.payload };
    }
    case SET_SELECTED_TIMEZONE: {
      return { ...state, selectedTimezone: action.payload };
    }
    case SET_TIMEZONE_LIST: {
      return { ...state, timezoneList: action.payload };
    }
    default:
      return state;
  }
};

export default authReducer;
